export const gamesData = (id, input) => {
return {id: id, user: input, day: 1, event: 1, energy: 5}
};
